<template>
  <div>
    <h1 class="mobiTitle white lg content" id="contentTitle">
      {{ $t("terms") }}
    </h1>
    <span v-if="lang_cutehub == 'slovakia'">
      <terms-sk-slovak />
    </span>
    <span v-else-if="lang_cutehub == 'czech'">
      <terms-cz-czech />
    </span>
    <span v-else>
      <terms-english :country="country_cutehub" />
    </span>
  </div>
</template>

<script>
import TermsSKSlovak from "./TermsSKSlovak";
import TermsCZCzech from "./TermsCZCzech";
import TermsEnglish from "./TermsEnglish";

import { mapGetters } from "vuex";

export default {
  computed: mapGetters(["lang_cutehub", "country_cutehub"]),
  components: {
    "terms-sk-slovak": TermsSKSlovak,
    "terms-cz-czech": TermsCZCzech,
    "terms-english": TermsEnglish,
  },
  methods: {},
};
</script>
<style scoped lang="scss">
.mobiFaq {
  margin: 25px 0px;
  .mobitxt {
    margin: 8px 0px;
    padding-left: 25px;
  }
  .mobiTitle {
    padding: 12px;
    background: #f1f1f1;
  }
  li {
    font-size: 1rem;
    line-height: 1.2;
    font-weight: 300;
    margin-bottom: 8px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/cutehub/Terms.vue